/**
 * Reports module theme — aliases app brand (Patient indigo SoT).
 *
 * Prefer importing from here in Reports UI so the module stays swappable
 * without reaching into Patients/. Color changes still flow from patientTheme.
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../../ui/brandTheme";

export const REPORT_THEME = BRAND_THEME;
export const REPORT_THEME_HEX = BRAND_THEME_HEX;

export const REPORT_ROLE_CHIP =
  "bg-indigo-50 text-indigo-700 border border-indigo-100";

export const REPORT_BTN = {
  soft: `inline-flex items-center justify-center gap-1 h-6 px-2 text-[11px] font-medium rounded border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.soft}`,
  clear:
    "inline-flex items-center gap-1 h-8 px-2.5 text-xs font-medium text-indigo-700 hover:bg-indigo-50 rounded-md border border-indigo-200 transition-colors whitespace-nowrap",
  modalClose:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

export const REPORT_FIELD = {
  search: `w-full h-8 pl-9 pr-8 text-sm bg-white border border-indigo-200 rounded-md text-slate-800 placeholder:text-slate-400 outline-none transition-colors ${BRAND_THEME.fieldFocus}`,
  select: `appearance-none h-8 min-w-[130px] pl-3 pr-8 text-sm rounded-md border border-indigo-200 text-slate-700 bg-white outline-none cursor-pointer transition-colors ${BRAND_THEME.fieldFocus}`,
  selectActive:
    "border-indigo-400 text-indigo-700 font-medium bg-indigo-50/60",
};

export const REPORT_MODAL = {
  backdrop:
    "fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40",
  panel:
    "w-full max-w-4xl h-[85vh] max-h-[90vh] rounded-xl border border-indigo-200 bg-white shadow-xl flex flex-col overflow-hidden",
  head: `flex items-start justify-between gap-3 px-4 py-3 border-b shrink-0 ${BRAND_THEME.modalHead}`,
  title: "text-base font-semibold text-slate-900",
  subtitle: "mt-0.5 text-[11px] text-slate-500",
  body: "flex-1 overflow-y-auto bg-slate-50/50 min-h-0",
  close:
    "inline-flex h-7 w-7 items-center justify-center rounded-md text-slate-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors shrink-0",
};

/** Progress fill — one brand tone across compliance columns. */
export const REPORT_PROGRESS = "bg-indigo-500";
